import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  Table,
  TableCell,
  TableRow,
  TableBody,
  TableHeader,
  TableHeaderCell,
} from 'semantic-ui-react';
import CloseSVG from '../../assets/icons/close.svg';
import {
  HIMS_PROJECT_DEVELOPMENT_ID,
  HIMS_COMPONENT_ID,
  HIMS_UNIT_NUMBER,
} from '../../constants/hims';

class ConfirmHIMSUnitSync extends Component {
  static propTypes = {
    open: PropTypes.bool,
    himsUnit: PropTypes.shape({
      id: PropTypes.string,
      reference: PropTypes.string,
    }),
    srUnit: PropTypes.shape({
      id: PropTypes.string,
      reference: PropTypes.string,
    }),
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  render() {
    const { himsUnit, srUnit } = this.props;
    return (
      <Modal
        className="himsModal"
        open={this.props.open === true}
        onClose={this.handleOnClose}
        size="tiny"
      >
        <Modal.Header>
          <div className="modal_header">
            {`Warning: This Showroom Unit No ${srUnit ? srUnit.reference : ''} already linked to another HIMS Unit No`}
            <Button
              basic
              className="closeButton"
              onClick={this.handleOnClose}
            >
              <img src={CloseSVG} alt="close" />
            </Button>
          </div>
        </Modal.Header>
        <Modal.Content>
          <Modal.Description style={{ paddingBottom: '1em' }}>
            <div>
              <Table celled fixed>
                <TableHeader>
                  <TableRow textAlign="center">
                    <TableHeaderCell collapsing />
                    <TableHeaderCell>Current</TableHeaderCell>
                    <TableHeaderCell>New</TableHeaderCell>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {
                    srUnit && himsUnit && srUnit.id !== himsUnit.id && (
                      <TableRow textAlign="center">
                        <TableCell collapsing><b>Showroom Unit No</b></TableCell>
                        <TableCell>{srUnit.reference}</TableCell>
                        <TableCell>{himsUnit.reference}</TableCell>
                      </TableRow>
                    )
                  }
                  {
                    srUnit && himsUnit && srUnit[HIMS_PROJECT_DEVELOPMENT_ID] !== himsUnit[HIMS_PROJECT_DEVELOPMENT_ID] && (
                      <TableRow textAlign="center">
                        <TableCell collapsing><b>Project Code</b></TableCell>
                        <TableCell>{srUnit[HIMS_PROJECT_DEVELOPMENT_ID]}</TableCell>
                        <TableCell>{himsUnit[HIMS_PROJECT_DEVELOPMENT_ID]}</TableCell>
                      </TableRow>
                    )
                  }
                  {
                    srUnit && himsUnit && srUnit[HIMS_COMPONENT_ID] !== himsUnit[HIMS_COMPONENT_ID] && (
                      <TableRow textAlign="center">
                        <TableCell collapsing><b>Component ID</b></TableCell>
                        <TableCell>{srUnit[HIMS_COMPONENT_ID]}</TableCell>
                        <TableCell>{himsUnit[HIMS_COMPONENT_ID]}</TableCell>
                      </TableRow>
                    )
                  }
                  {
                    srUnit && himsUnit && srUnit[HIMS_UNIT_NUMBER] !== himsUnit[HIMS_UNIT_NUMBER] && (
                      <TableRow textAlign="center">
                        <TableCell collapsing><b>HIMS Unit No</b></TableCell>
                        <TableCell>{srUnit[HIMS_UNIT_NUMBER]}</TableCell>
                        <TableCell>{himsUnit[HIMS_UNIT_NUMBER]}</TableCell>
                      </TableRow>
                    )
                  }
                </TableBody>
              </Table>
              <p style={{ marginBottom: '1.5em', color: '#596975' }}>
                You are trying to assign a Showroom Unit that is already linked to an existing HIMS Unit.&nbsp;
                If you proceed, it could result in data conflicts and inconsistencies within the HIMS system.&nbsp;
                This may lead to errors and unexpected behavior.<br /><br />
                Are you sure you want to replace it?
              </p>
            </div>
          </Modal.Description>
          <div style={{ marginTop: '1.5em', textAlign: 'right' }}>
            <Button basic style={{ marginRight: '1em' }} onClick={this.handleOnClose} icon="cancel" content="No" />
            <Button primary onClick={this.props.onConfirm} icon="checkmark" content="Yes" />
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default ConfirmHIMSUnitSync;



// WEBPACK FOOTER //
// ./src/containers/modals/ConfirmHIMSUnitSync.jsx